import {  Component, Input, OnInit } from '@angular/core';
import { UntypedFormArray, UntypedFormGroup } from '@angular/forms';
import { camps } from '../../../../../models/models.generated';
import { CampsDetailsFormStateService } from '../../camp-details-form-state-service';

@Component({
    selector: 'app-sessions-list',
    templateUrl: './sessions-list.component.html',
    styleUrls: ['./sessions-list.component.scss'],
    standalone: false
})
export class SessionsListComponent implements OnInit {

    @Input() public form: UntypedFormGroup;

    @Input() context: camps.CampDefinitionCreationContext;

    constructor(private state: CampsDetailsFormStateService) {

    }

    ngOnInit(): void {
    }

    public isOpenChanged($event, session: UntypedFormGroup) {
        session.controls['isOpen'].setValue($event);
    }

}
